import { Col } from "react-bootstrap";

import { BsGithub } from "react-icons/bs";
import { FaExternalLinkAlt } from "react-icons/fa";

export const ProjectCard = ({ title, description, imgUrl, github, link }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} alt="img" />
        <div className="proj-txtx ">
          <h4>{title}</h4>
          <span>{description}</span>
          <div className="btn-grp1">
            <a
              href={github}
              target="_blank"
              className="anchor"
              rel="noreferrer"
            >
              <BsGithub size={32} />
            </a>
            <a href={link} className="anchor" rel="noreferrer" target="_blank">
              <FaExternalLinkAlt />
            </a>
          </div>
        </div>
      </div>
    </Col>
  );
};
